class SlideTwoImages extends HTMLElement {
  constructor() {
    super();
    this.visualState = 'intro'; // intro | step-one
    this.isMobile = false;
    this.hasScrolledPastThreshold = false;
  }

  connectedCallback() {
    this.grid = this.querySelector('.Index_column_text_with_image_grid');
    this.isMobile = window.innerWidth < 768;

    if (this.isMobile) {
      const mediaElement = this.querySelector('.Index_column_text_with_image_media');
      const hoverImages = this.querySelector('.slide-two-images__hover-images');

      if (mediaElement && hoverImages) {
        const updateHoverPosition = () => {
          const mediaRect = mediaElement.getBoundingClientRect();
          const containerRect = this.getBoundingClientRect();
          
          const topOffset = mediaRect.top - containerRect.top;
          const bottomOffset = containerRect.bottom - mediaRect.bottom;
          
          hoverImages.style.top = `${topOffset}px`;
          hoverImages.style.bottom = `${bottomOffset}px`;
        };

        updateHoverPosition();

        const scrollListener = () => updateHoverPosition();
        const resizeListener = () => { updateHoverPosition(); this.isMobile = window.innerWidth < 768; };

        window.addEventListener('scroll', scrollListener, { passive: true });
        window.addEventListener('resize', resizeListener, { passive: true });
        
        // Store references for cleanup
        this.scrollListener = scrollListener;
        this.resizeListener = resizeListener;
      }
    } else {
      this.updateClasses(); 
      this.checkInitialLock();
      
      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  }

  checkInitialLock() {
    // Only lock if at the very top
    if (window.scrollY < 1) {
      this.enableInitialLock();
    }
  }
  
  handleScroll() {
    if (this.isMobile) return;
    
    if (window.scrollY > 10) {
      this.hasScrolledPastThreshold = true;
    }

    if (!this.initialLockActive && window.scrollY < 1 && this.hasScrolledPastThreshold) {
      this.enableInitialLock();
      this.hasScrolledPastThreshold = false;
      window.scrollTo(0, 0);
    }
  }

  enableInitialLock() {
    this.initialLockActive = true;
    this.isAnimating = false;
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 0); 
    this.setVisualState('intro');
    
    this.handleInitialLockWheel = this.handleInitialLockWheel.bind(this);
    this.handleInitialLockTouchStart = this.handleInitialLockTouchStart.bind(this);
    this.handleInitialLockTouchMove = this.handleInitialLockTouchMove.bind(this);

    window.addEventListener('wheel', this.handleInitialLockWheel, { passive: false });
    window.addEventListener('touchstart', this.handleInitialLockTouchStart, { passive: false });
    window.addEventListener('touchmove', this.handleInitialLockTouchMove, { passive: false });
  }

  disableInitialLock() {
    if (!this.initialLockActive) return;
    this.initialLockActive = false;
    document.body.style.overflow = '';
    

    window.removeEventListener('wheel', this.handleInitialLockWheel);
    window.removeEventListener('touchstart', this.handleInitialLockTouchStart);
    window.removeEventListener('touchmove', this.handleInitialLockTouchMove);
  }

  handleInitialLockWheel(e) {
    if (!this.initialLockActive) return;
    
    e.preventDefault();

    if (e.deltaY > 0) {
      this.processLockStep('next');
    } else if (e.deltaY < 0) {
      this.processLockStep('prev');
    }
  }

  handleInitialLockTouchStart(e) {
    if (!this.initialLockActive) return;
    this.lockTouchStartY = e.touches[0].clientY;
  }

  handleInitialLockTouchMove(e) {
    if (!this.initialLockActive) return;
    if (e.cancelable) e.preventDefault();
    
    const currentY = e.touches[0].clientY;
    const delta = this.lockTouchStartY - currentY;
    
    if (Math.abs(delta) > 10) {
      this.lockTouchStartY = currentY; 
      if (delta > 0) {
        this.processLockStep('next');
      } else {
        this.processLockStep('prev');
      }
    }
  }

  processLockStep(direction) {
      if (this.isAnimating) return;

      if (direction === 'next') {
        if (this.visualState === 'intro') {
          this.isAnimating = true;
          this.setVisualState('step-one');
          
          setTimeout(() => {
            this.isAnimating = false;
          }, 500); // 0.5s match CSS transition

        } else if (this.visualState === 'step-one') {
          if (!this.isMobile) {
            // this.isAnimating = true;
            // this.setVisualState('step-two');
            
            // setTimeout(() => {
            //   this.isAnimating = false;
            // }, 500); // 0.5s match CSS transition
          } else {
          }
          this.disableInitialLock();
        }
        // else if (this.visualState === 'step-two') {
        //   this.disableInitialLock();
        // }
      } else if (direction === 'prev') {
        if (this.visualState === 'step-two') {
          // this.isAnimating = true;
          // this.setVisualState('step-one');
          // setTimeout(() => {
          //   this.isAnimating = false;
          // }, 500);
        } else if (this.visualState === 'step-one') {
          this.isAnimating = true;
          this.setVisualState('intro');
          setTimeout(() => {
            this.isAnimating = false;
          }, 500);
        }
      }
  }
  
  disconnectedCallback() {
    if (this.scrollListener) window.removeEventListener('scroll', this.scrollListener);
    if (this.resizeListener) window.removeEventListener('resize', this.resizeListener);
    if (this.handleScroll) window.removeEventListener('scroll', this.handleScroll); // Clean up new listener
  }

  setVisualState(state) {
    if (this.visualState === state) return;
    this.visualState = state;
    this.updateClasses();
  }

  updateClasses() {
    // Shared Elements
    if (!this.grid) this.grid = this.querySelector('.Index_column_text_with_image_grid');

    if (this.visualState === 'intro') {
      // this.classList.remove('step-one', 'step-two', 'is-collapsed');
      this.classList.remove('step-one', 'is-collapsed');
      if (this.grid) this.grid.classList.add('is-invisible');
    } 
    else if (this.visualState === 'step-one') {
      this.classList.add('step-one', 'is-collapsed');
      // this.classList.remove('step-two');
      if (this.grid) this.grid.classList.remove('is-invisible');
    } 
    // else if (this.visualState === 'step-two') {
    //   this.classList.add('step-two', 'is-collapsed'); // Persist collapsed state
    //   this.classList.remove('step-one');
    //   if (this.grid) this.grid.classList.remove('is-invisible');
    // }
  }

}

customElements.define('slide-two-images', SlideTwoImages);
